export default "__VITE_ASSET__DAMPcGnv__"